<template>
  <nav>
    <div class="btn-picture-book">
      <router-link :to="{ name: 'picture-book' }">
        <img src="@/assets/images/top/zukan_title.png" alt="びせいぶつずかん">
        <img v-if="hasNewTitle" class="ico-new" src="@/assets/images/new_icon.png" alt="New">
      </router-link>
    </div>
  </nav>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
export default {
  name: 'GlobalNavigation',
  components: {
  },
  setup() {
    const store = useStore();
    const hasNewTitle = computed(() => store.getters.hasNewTitle);
    return {
      hasNewTitle,
    }
  }
}
</script>

<style scoped lang="scss">
nav {
  position: fixed;
  bottom: 2vh;
  bottom: 2dvh;
  left: 5%;
  width: 90%;
  .btn-picture-book {
    max-width: 100%;
    width: 45vh;
    width: 45dvh;
    margin: 0 auto;
    position: relative;
    a {
      width: 100%;
      display: block;
      .ico-new {
        position: absolute;
        top: -30%;
        right: -2%;
        width: 15%;
      }
    }
  }
}

// @media (min-width: 768px) {
//   nav {
//     left: 15%;
//     width: 70%;
//   }
// }

</style>